import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

const STEPS = ['选择类型', '基础信息', '上传图片', '添加链接', '正文内容', '预览发布'];

export default class ResourceComposerModal extends Modal {
  step = 0;
  category = 'asset';
  resourceType = '';
  resourceTitle = '';
  body = '';
  currentVersion = '';
  licenseType = '';
  sourceType = 'original';
  language = 'zh-Hans';
  isFree = true;
  tags = new Set<string>();
  software: string[] = [];
  formats: string[] = [];
  links: any[] = [];
  images: any[] = [];
  draftToken = 'draft-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  uploading = false;
  submitting = false;
  error = '';

  className() {
    return 'ResourceComposerModal';
  }

  title() {
    return '发布资源';
  }

  content() {
    const rh = app.forum.attribute('resourceHub') || {};

    return (
      <div className="ResourceComposer">
        <div className="ComposerSteps">
          {STEPS.map((s, i) => (
            <div className={'Step' + (i === this.step ? ' active' : '') + (i < this.step ? ' done' : '')}>
              <div className="StepDot">{i + 1}</div>
              <div className="StepLabel">{s}</div>
            </div>
          ))}
        </div>

        <div className="ComposerBody">
          {this.step === 0 && this.stepType(rh)}
          {this.step === 1 && this.stepBasic(rh)}
          {this.step === 2 && this.stepImages()}
          {this.step === 3 && this.stepLinks(rh)}
          {this.step === 4 && this.stepContent()}
          {this.step === 5 && this.stepPreview(rh)}
        </div>

        <div className="ComposerFooter">
          {this.error && <div className="ComposerError">{this.error}</div>}
          {this.step > 0 && (
            <Button className="Button" onclick={() => this.goto(this.step - 1)}>
              上一步
            </Button>
          )}
          {this.step < 5 && (
            <Button className="Button Button--primary" onclick={() => this.goto(this.step + 1)}>
              下一步
            </Button>
          )}
          {this.step === 5 && (
            <Button className="Button Button--primary" loading={this.submitting} onclick={() => this.submit()}>
              发布
            </Button>
          )}
        </div>
      </div>
    );
  }

  goto(step: number) {
    if (step === 1 && !this.resourceType) {
      this.error = '请先在下方选择资源类型';
      m.redraw();
      return;
    }
    if (step === 2 && !this.resourceTitle.trim()) {
      this.error = '请先填写标题';
      m.redraw();
      return;
    }
    this.error = '';
    this.step = step;
    m.redraw();
  }

  // Step 0：选类型
  stepType(rh: any) {
    const categories = rh.categories || [];
    return (
      <div className="StepType">
        <h4>你想发布什么？</h4>
        <div className="CategoryGrid">
          {categories.map((cat: any) => (
            <div
              className={'CategoryCard' + (this.category === cat.key ? ' active' : '')}
              onclick={() => {
                this.category = cat.key;
                this.resourceType = '';
                m.redraw();
              }}
            >
              <div className="CategoryIcon">
                <i className={cat.icon} />
              </div>
              <div className="CategoryLabel">{cat.label}</div>
            </div>
          ))}
        </div>
        <div className="TypeGrid">
          {(categories.find((c: any) => c.key === this.category)?.types || []).map((t: any) => (
            <div
              className={'TypeItem' + (this.resourceType === t.key ? ' active' : '')}
              onclick={() => {
                this.resourceType = t.key;
                m.redraw();
              }}
            >
              {t.label}
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Step 1：基础信息
  stepBasic(rh: any) {
    return (
      <div className="StepBasic">
        <label>
          标题 *
          <input className="FormControl" value={this.resourceTitle} oninput={(e: any) => (this.resourceTitle = e.target.value)} />
        </label>
        <div className="FormRow">
          <label>
            资源版本
            <input className="FormControl" value={this.currentVersion} oninput={(e: any) => (this.currentVersion = e.target.value)} />
          </label>
          <label>
            授权 (License)
            <input className="FormControl" value={this.licenseType} oninput={(e: any) => (this.licenseType = e.target.value)} placeholder="如 CC BY" />
          </label>
        </div>
        <div className="FormRow">
          <label>
            来源
            <select className="FormControl" value={this.sourceType} onchange={(e: any) => (this.sourceType = e.target.value)}>
              {(rh.sourceTypes || []).map((s: any) => (
                <option value={s.key}>{s.label}</option>
              ))}
            </select>
          </label>
          <label>
            语言
            <select className="FormControl" value={this.language} onchange={(e: any) => (this.language = e.target.value)}>
              <option value="zh-Hans">中文</option>
              <option value="en">English</option>
              <option value="ja">日本語</option>
              <option value="other">其他</option>
            </select>
          </label>
        </div>
        <label className="Checkbox">
          <input type="checkbox" checked={this.isFree} onchange={(e: any) => (this.isFree = e.target.checked)} />
          免费资源
        </label>

        <div className="FieldGroup">
          <div className="FieldGroupTitle">适用软件（可多选）</div>
          <div className="ChipGroup">
            {(rh.software || []).map((s: any) => (
              <span
                className={'Chip' + (this.software.includes(s.key) ? ' active' : '')}
                onclick={() => this.toggle(this.software, s.key)}
              >
                {s.label}
              </span>
            ))}
          </div>
        </div>

        <div className="FieldGroup">
          <div className="FieldGroupTitle">资源格式（可多选）</div>
          <div className="ChipGroup">
            {(rh.formats || []).map((f: any) => (
              <span
                className={'Chip' + (this.formats.includes(f.key) ? ' active' : '')}
                onclick={() => this.toggle(this.formats, f.key)}
              >
                {f.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Step 2：图片
  stepImages() {
    return (
      <div className="StepImages">
        <div className="UploadArea">
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            multiple
            onchange={(e: any) => this.uploadFiles(e.target.files)}
          />
          <p className="Hint">支持 JPEG / PNG / WebP，单张 ≤3MB，最多 8 张</p>
          {this.uploading && <p>上传中…</p>}
        </div>
        <div className="ImageGrid">
          {this.images.map((img: any, i: number) => (
            <div className="ImageCard">
              <img src={img.attributes.thumbnailUrl} alt="" />
              <span className="Badge">{i === 0 ? '封面' : '预览'}</span>
              <Button
                className="Button Button--icon Button--danger"
                icon="fas fa-times"
                onclick={() => {
                  this.images.splice(i, 1);
                  m.redraw();
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Step 3：链接
  stepLinks(rh: any) {
    return (
      <div className="StepLinks">
        {this.links.map((link: any, i: number) => (
          <div className="LinkEditor">
            <div className="FormRow">
              <label>
                类型
                <select className="FormControl" value={link.linkType} onchange={(e: any) => (link.linkType = e.target.value)}>
                  {(rh.linkTypes || []).map((t: any) => (
                    <option value={t.key}>{t.label}</option>
                  ))}
                </select>
              </label>
              <label>
                提供方
                <select className="FormControl" value={link.provider} onchange={(e: any) => (link.provider = e.target.value)}>
                  {(rh.providers || []).map((p: any) => (
                    <option value={p.key}>{p.label}</option>
                  ))}
                </select>
              </label>
            </div>
            <label>
              链接 URL *
              <input
                className="FormControl"
                value={link.url}
                placeholder="https://…"
                oninput={(e: any) => {
                  link.url = e.target.value;
                }}
              />
            </label>
            <div className="FormRow">
              <label>
                提取码
                <input className="FormControl" value={link.extractCode || ''} oninput={(e: any) => (link.extractCode = e.target.value)} />
              </label>
              <label>
                解压密码
                <input className="FormControl" value={link.password || ''} oninput={(e: any) => (link.password = e.target.value)} />
              </label>
            </div>
            <Button className="Button Button--danger" onclick={() => { this.links.splice(i, 1); m.redraw(); }}>
              删除
            </Button>
          </div>
        ))}
        <Button className="Button" onclick={() => this.links.push({ linkType: 'download', provider: 'baidu', url: '', extractCode: '', password: '' })}>
          + 添加地址
        </Button>
      </div>
    );
  }

  // Step 4：正文
  stepContent() {
    return (
      <div className="StepContent">
        <label>
          正文（支持 Markdown）*
          <textarea className="FormControl" rows={12} value={this.body} oninput={(e: any) => (this.body = e.target.value)} placeholder="资源介绍、使用方法、安装方式、注意事项、更新日志…" />
        </label>
      </div>
    );
  }

  // Step 5：预览
  stepPreview(rh: any) {
    return (
      <div className="StepPreview">
        <h3>{this.resourceTitle || '(未填标题)'}</h3>
        <div className="PreviewMeta">
          <span>分类：{rh.categories?.find((c: any) => c.key === this.category)?.label}</span>
          <span>类型：{rh.categories?.find((c: any) => c.key === this.category)?.types?.find((t: any) => t.key === this.resourceType)?.label}</span>
          <span>图片：{this.images.length} 张</span>
          <span>链接：{this.links.length} 个</span>
          <span>软件：{this.software.join(', ') || '—'}</span>
        </div>
        {this.images[0] && <img className="PreviewCover" src={this.images[0].attributes.thumbnailUrl} alt="" />}
      </div>
    );
  }

  toggle(list: string[], key: string) {
    const i = list.indexOf(key);
    if (i === -1) list.push(key);
    else list.splice(i, 1);
    m.redraw();
  }

  async uploadFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      if (this.images.length >= 8) break;
      await this.uploadImage(files[i]);
    }
  }

  async uploadImage(file: File) {
    const body = new FormData();
    body.append('image', file);
    body.append('draftToken', this.draftToken);
    body.append('type', this.images.length === 0 ? 'cover' : 'preview');

    this.uploading = true;
    m.redraw();

    try {
      const result = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/resource-images',
        serialize: (raw: any) => raw,
        body,
      });
      this.images.push(result.data);
    } catch (e) {
      this.showError(e);
    } finally {
      this.uploading = false;
      m.redraw();
    }
  }

  async submit() {
    if (!this.resourceTitle.trim() || !this.body.trim()) {
      app.alerts.show({ type: 'error' }, '标题和正文不能为空');
      return;
    }

    this.submitting = true;
    m.redraw();

    try {
      const result = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/resources',
        body: {
          data: {
            type: 'resources',
            attributes: {
              title: this.resourceTitle,
              content: this.body,
              category: this.category,
              resourceType: this.resourceType,
              currentVersion: this.currentVersion,
              licenseType: this.licenseType,
              sourceType: this.sourceType,
              language: this.language,
              isFree: this.isFree,
              software: this.software,
              formats: this.formats,
              links: this.links.filter((l) => l.url),
              draftToken: this.draftToken,
              tags: Array.from(this.tags),
            },
          },
        },
      });

      app.modal.close();
      const discussionId = result.data.relationships.discussion.data.id;
      m.route.set(app.route('discussion', { id: discussionId }));
    } catch (e) {
      this.showError(e);
    } finally {
      this.submitting = false;
      m.redraw();
    }
  }

  showError(e: any) {
    const detail = e?.response?.errors?.[0]?.detail || e?.message || '操作失败';
    app.alerts.show({ type: 'error' }, detail);
  }
}
